// # Filename: src/components/poker/shared/SeatRoleChip.jsx
// Dealer/small-blind/big-blind badge, used by both desktop (felt hole cards) and
// mobile (hero seat marker).

import React from "react";

export default function SeatRoleChip({ label, className = "", style = undefined, elastic = false }) {
  if (!label) return null;
  const styles = {
    D: "bg-white text-slate-950",
    SB: "bg-sky-300 text-slate-950",
    BB: "bg-amber-300 text-slate-950",
  };
  const sizeClassName = elastic
    ? "h-[clamp(17px,1.9cqw,24px)] w-[clamp(17px,1.9cqw,24px)] min-w-0 px-0 text-[clamp(6px,0.78cqw,10px)]"
    : "h-6 w-6 min-w-0 px-0 text-[10px]";
  return (
    <span
      className={[
        "absolute z-30 grid place-items-center rounded-full border border-slate-950/55 font-black shadow-[0_0_0_2px_rgba(255,255,255,0.18),0_8px_16px_rgba(0,0,0,0.42)]",
        sizeClassName,
        styles[label] || styles.D,
        className,
      ].join(" ")}
      style={style}
    >
      {label}
    </span>
  );
}
